import React, {useState} from "react";
import { ToastContainer } from "react-toastify";
import {MapLiveView} from "./MapLiveView";
import {TabularLiveView} from "./tableView/TabularLiveView";


function Tabs() {
    const [toggleState, setToggleState] = useState(1);

    const toggleTab = (index) => {
        setToggleState(index);
    };

    return (
        <div className="container-block">
            <ToastContainer/>
            <div className="bloc-tabs">
                <button
                    className={toggleState === 1 ? "tabs active-tabs" : "tabs"}
                    onClick={() => toggleTab(1)}
                >
                    MAP VIEW
                </button>

                <button
                    className={toggleState === 2 ? "tabs active-tabs" : "tabs"}
                    onClick={() => toggleTab(2)}
                >
                    Table View
                </button>

            </div>

            <div className="content-tabs">

                <MapLiveView isActive={toggleState === 1}/>

                <TabularLiveView isActive={toggleState === 2}/>

            </div>
        </div>
    );
}

export default Tabs;
